module.exports = __webpack_public_path__ + "img/bourriche-ostra-regal.39857374.jpg";